import React, { useState, useEffect } from "react";
import Circle from "./Circle/Circle";
import "./Interaction.scss";
import Button from '../../partials/Button';
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import { evaluatedPropsToName } from "ajv/dist/compile/util";
import DogEar from "../../partials/DogEar/DogEar";
import { props } from "bluebird";
import Scroll from "../../partials/Scroll/Scroll";
import Instructions from "../../partials/Instructions/Instructions"

const Interaction5 = ({ data, breadcrumbs, goBackToPreviousSegment, onComplete }) => {
  const [selectedCircleId, setSelectedCircleId] = useState(null);
  const [secondSelectedCircleId, setSecondSelectedCircleId] = useState(null);
  const circles = data.container;
  const selectedCircle = circles[selectedCircleId];
  const secondSelectedCircle = circles[secondSelectedCircleId];
  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [audioHovered, setAudioHovered] = useState(false);
  // const [checkCircleStatus, setCheckCircleStatus] = useState([]);

  //visitedCircleRelations is an array of circles, each element is another array of booleans representing that circle's relations' visited status
  const [visitedCircleRelations, setVisitedCircleRelations] = useState(circles.map((circle) => circle.relations.map(relation => false)));

  const checkVisitedCircles = arr => arr.every(value => value === true);

  const displayNextButton = true;

  const getNextRelationId = (direction) => {
    return selectedCircle.relations.findIndex((relation) => relation.circleId == secondSelectedCircleId) + direction;
  }

  const displayArrow = (direction) => {
    let nextRelationId = getNextRelationId(direction);
    if (nextRelationId < 0 || nextRelationId >= selectedCircle.relations.length) {
      return false
    } else {
      return true
    }
  }

  useEffect(() => {
    if (selectedCircleId !== null && setSecondSelectedCircleId !== null) {
      const relationId = selectedCircle.relations.findIndex(relation => relation.circleId === secondSelectedCircleId)
      visitedCircleRelations[selectedCircleId][relationId] = true;
      setVisitedCircleRelations(visitedCircleRelations.map(x => x))
    }
  }, [selectedCircleId, secondSelectedCircleId])

  const onArrowClicked = (direction) => {
    let nextRelationId = getNextRelationId(direction);
    if (displayArrow(direction)) {
      setSecondSelectedCircleId(selectedCircle.relations[nextRelationId].circleId);
    }
  }


  const circleClicked = (circle) => {
    // selectedCircle ? setSecondSelectedCircle(circle) : setSelectedCircle(circle);
    // If there is a selected circle, use the circle to set the second selected circle
    // if there is no selected circle, use the circle to set the selected circle
    // if there is a selected circle and is === to the circle the user is trying to click, set selected circle to null
    // 

    if (selectedCircle?.id == circle.id) {
      setSelectedCircleId(null)
      setSecondSelectedCircleId(null)
    } else if (secondSelectedCircle?.id == circle.id) {
      setSecondSelectedCircleId(null)
    } else if (!selectedCircle || !selectedCircle.relations.some((relation) => relation.circleId == circle.id)) {
      setSelectedCircleId(circle.id)
      setSecondSelectedCircleId(null)
    } else {
      setSecondSelectedCircleId(circle.id)
      // setCheckCircleStatus
    }

  };

  return (
    <InteractionContainer withFrame={true} breadcrumbs={breadcrumbs}>
      {console.log(visitedCircleRelations, "visitedCircleRelations")}
      <div className="int5-wrapper">
        <div className="back-btn-container">
          <Button variant='back' text="back" onClick={goBackToPreviousSegment} />
        </div>
        <Instructions body={data.maincontentfooter} />
        <div className="border-container">
          <div className="left-container">
            <div className="circle-container">
              {/* <div className="title-container">
              <h2>{data.title}</h2>
              <hr />
            </div> */}
              <div>
                <Circle
                  circles={circles}
                  selectedCircleId={selectedCircleId}
                  secondSelectedCircleId={secondSelectedCircleId}
                  circleClicked={circleClicked}
                  visitedCircleRelations={visitedCircleRelations}
                  title={data.title}
                />
              </div>
            </div>

          </div>
          <div className="information-container">

            {selectedCircle
              ?
              (<div className="image-container" role="img" aria-label={selectedCircle.heading} style={{ backgroundImage: `url(${selectedCircle.contentimgurl})` }}>
              </div>)
              :
              (<div className="image-container" role="img" aria-label={data.title} style={{ backgroundImage: `url(${data.maincontentimgurl})` }}></div>)
            }

            <div className="content-container">

              {!selectedCircle ?
                (<>

                  <div className="content-display-wrapper">
                    <Scroll>
                      <div className="content-class" >
                        {/* Commented the code as per ticket NS-625 */}
                        {/* <div className="audio-button-container">
                        <div>
                          <div className="show-audio-button" onMouseEnter={() => setAudioHovered(true)} onMouseLeave={() => setAudioHovered(false)} onClick={() => {setShowAudioPlayer(!showAudioPlayer)}}>
                              <img className={!audioHovered && !showAudioPlayer ? '' : 'display-none'} src={'media/img/icons/icn-ListenEar.svg'} alt="" />
                              <img className={!audioHovered && showAudioPlayer ? '' : 'display-none'} src={'media/img/icons/icn-ListenEar-selected.svg'} alt="" />
                              <img className={audioHovered ? '' : 'display-none'} src={'media/img/icons/icn-ListenEar-hover.svg'} alt="" />
                          </div>  
                        </div>
                      </div> */}
                        <div dangerouslySetInnerHTML={{ __html: data.maincontent }}>
                        </div>
                      </div>
                    </Scroll>
                  </div>

                </>)
                :
                (

                  <div className={`content-display-wrapper ${showAudioPlayer || displayNextButton ? 'shortened-view' : ''}`}>

                    <div className="content-nav-button-container" onClick={() => { onArrowClicked(-1) }} style={{ opacity: displayArrow(-1) ? 1 : .2 }}>
                      <div>
                        <img className="arrow-button" src="media/img/icons/arrow-left.svg" alt="" />
                      </div>
                    </div>
                    <Scroll>
                      <div className="content-class">
                        {/* Commented the code as per ticket NS-625 */}
                        {/* <div className="audio-button-container">
                          <div>
                            <div className="show-audio-button" onMouseEnter={() => setAudioHovered(true)} onMouseLeave={() => setAudioHovered(false)} onClick={() => {setShowAudioPlayer(!showAudioPlayer)}}>
                                <img className={!audioHovered && !showAudioPlayer ? '' : 'display-none'} src={'media/img/icons/icn-ListenEar.svg'} alt="" />
                                <img className={!audioHovered && showAudioPlayer ? '' : 'display-none'} src={'media/img/icons/icn-ListenEar-selected.svg'} alt="" />
                                <img className={audioHovered ? '' : 'display-none'} src={'media/img/icons/icn-ListenEar-hover.svg'} alt="" />
                            </div>  
                          </div>
                        </div> */}

                        <h3 className="element-content-header">{secondSelectedCircle ? selectedCircle.relations.find((relation) => relation.circleId == secondSelectedCircleId)?.heading : selectedCircle.heading}</h3>
                        <div className="content-text"
                          dangerouslySetInnerHTML={{ __html: secondSelectedCircle ? selectedCircle.relations.find((relation) => relation.circleId == secondSelectedCircleId)?.content : selectedCircle.content }}>
                        </div>
                      </div>
                    </Scroll>
                    <div className="content-nav-button-container" onClick={() => { onArrowClicked(1) }} style={{ opacity: displayArrow(1) ? 1 : .2 }}>
                      <div>
                        <img className="arrow-button" src="media/img/icons/arrow-right.svg" />
                      </div>
                    </div>
                  </div>

                )}


              {(displayNextButton || showAudioPlayer) ? (<div className="audio-and-button-container">
                {showAudioPlayer && <div className='audio-container'>
                  <p className="audio-title-class">{selectedCircle ? selectedCircle.audiotitle : data.audiotitle}</p>
                  <audio controls>
                    <source src={selectedCircle ? selectedCircle.audiourl : data.audiourl} type="audio/mpeg" />
                  </audio>
                </div>}
                {displayNextButton &&
                  <Button text="Next" className="" onClick={() => onComplete()} />}
              </div>)
                :
                ""}
            </div>

          </div>
        </div>
      </div>
    </InteractionContainer>
  );
};

export default Interaction5;
